import React from "react";
import { TextProps } from ".";

export const Text: React.FunctionComponent<TextProps> = ({
  children,
  color,
  preset,
  className,
  font,
  id,
  ...rest
}) => {
  return (
    <p
      className={`text-${color ?? "stone-700"} text-${preset ?? "body2"}${
        font ? ` font-${font}` : ""
      }${className ? " " + className : ""}`}
      {...rest}
      id={id}
      data-testid={id}
    >
      {children}
    </p>
  );
};
